import React, {Component} from 'react'
import DocumentTitle from 'react-document-title'
import uniqid from 'uniqid'

import style from './vacancy.sass'

import {vacancyData} from './vacancyData'

class Vacancy extends Component {
  render() {
    const {vacancy} = this.props.match.params
    const data = vacancyData[vacancy]
    if (!data) {
      return null
    }
    return(
      <div styleName='wrapper'>
        <DocumentTitle title={data.title}/>
        <div styleName='banner'>
          <h3>{data.title}</h3>
        </div>
        <section className='bg-white' styleName='container'>
          <div className='landing-container'>
            <h2>Job Description</h2>
            <p>{data.description}</p>
            {!!data.responsibilities.length &&
              [<h2 key='title'>Responsibilities:</h2>,
                <ul key='list'>
                  {data.responsibilities.map(item =>
                    <li key={uniqid()}>{item}</li>
                  )}
                </ul>]
            }
            <h2>Requirements:</h2>
            <ul>
              {data.requirements.map(item =>
                <li key={uniqid()}>{item}</li>
              )}
            </ul>
            <h2>Nice to have:</h2>
            <ul>
              {data['nice-to-have'].map(item =>
                <li key={uniqid()}>{item}</li>
              )}
            </ul>
            <h2>Benefits:</h2>
            <ul>
              {data.benefits.map(item =>
                <li key={uniqid()}>{item}</li>
              )}
            </ul>
          </div>
        </section>
      </div>
    )
  }
}

export default Vacancy
